module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-list",
    class: {
      'tabs-list--large': _vm.isLarge
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('div', {
      key: tab,
      staticClass: "tabs-list__tab",
      class: {
        'tabs-list__tab--selected': _vm.selected === tab,
      },
      on: {
        "click": function($event) {
          return _vm.onSelect(tab)
        }
      }
    }, [_vm._v("\n    " + _vm._s(tab) + "\n  ")])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6745c30e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Tabslist.vue
// module id = 1644
// module chunks = 1